import { createGlobalStyle, css } from "styled-components";
import { BREAK_POINT } from "../constants";

const GlobalStyle = createGlobalStyle`${css`
  @font-face {
    font-family: "PyeongChang";
    font-weight: 700;
    src: local("PyeongChang Bold"), local("PyeongChang-Bold"),
      url("/fonts/PyeongChang-Bold.ttf") format("truetype");
    font-display: fallback;
  }

  @font-face {
    font-family: "PyeongChang";
    font-weight: 400;
    src: local("PyeongChang Regular"), local("PyeongChang-Regular"),
      url("/fonts/PyeongChang-Regular.ttf") format("truetype");
    font-display: fallback;
  }

  @font-face {
    font-family: "Pretendard";
    font-weight: 300;
    src: url("/fonts/Pretendard-Light.woff") format("woff");
    font-display: fallback;
  }

  @font-face {
    font-family: "Pretendard";
    font-weight: 400;
    src: url("/fonts/Pretendard-Regular.woff") format("woff");
    font-display: fallback;
  }

  @font-face {
    font-family: "Pretendard";
    font-weight: 500;
    src: url("/fonts/Pretendard-Medium.woff") format("woff");
    font-display: fallback;
  }

  @font-face {
    font-family: "Pretendard";
    font-weight: 700;
    src: url("/fonts/Pretendard-Bold.woff") format("woff");
    font-display: fallback;
  }

  * {
    margin: 0;
    padding: 0;
    font: inherit;
    color: inherit;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    font-family: "PyeongChang", "Pretendard";
    user-select: none;
  }
  *:focus {
    outline: 0;
    outline: none;
  }
  *,
  :after,
  :before {
    box-sizing: border-box;
  }
  html {
    overscroll-behavior: none;
    font-size: 62.5%; // 10px

    @media (max-width: ${BREAK_POINT.tablet}) {
      font-size: 50%; //8px
    }
    @media all and (max-width: ${BREAK_POINT.mobile}) {
      font-size: 50%; // 8px
    }
  }

  body {
    overflow: hidden !important;
  }

  img {
    width: 100%;
    height: 100%;
  }

  img,
  picture,
  video,
  canvas,
  svg {
    display: block;
  }
  button {
    background: none;
    border: 0;
    cursor: pointer;
  }
  a {
    text-decoration: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  ul {
    list-style: none;
  }
  ::-webkit-scrollbar {
    display: none;
  }

  :root {
    -webkit-tap-highlight-color: transparent;
    -webkit-text-size-adjust: 100%;
    text-size-adjust: 100%;
    line-height: 1.5;
    overflow-wrap: break-word;
    -moz-tab-size: 4;
    tab-size: 4;
    cursor: default;

    --app-height: 100%;
    --primary: #f176ae;
    --shadow: #c2c2c2;
    --palePink: #fce0e8;
    --white: #ffffff;
    --black: #000000;
    --darkPrimary: #864b6f;
    --lightSmoke: #ebebeb;
    --pink: #ffdceb;
  }
`}`;

export default GlobalStyle;
